import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28156b82")

_pushScopeId("data-v-28156b82")
const _hoisted_1 = {
  key: 0,
  class: "card hotelCard hoverShadow bgw"
}
const _hoisted_2 = { class: "hotelCard__head" }
const _hoisted_3 = { class: "hotelCard__head__service" }
const _hoisted_4 = { class: "hotelCard__main" }
const _hoisted_5 = { class: "dataInfo" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "dataInfo__type" }, "Заезд", -1)
const _hoisted_7 = { class: "dataInfo__data" }
const _hoisted_8 = { class: "dataInfo__data__data" }
const _hoisted_9 = { class: "dayName" }
const _hoisted_10 = { class: "dataInfo__data__time" }
const _hoisted_11 = { class: "dataInfo" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "dataInfo__type" }, "Выезд", -1)
const _hoisted_13 = { class: "dataInfo__data" }
const _hoisted_14 = { class: "dataInfo__data__data" }
const _hoisted_15 = { class: "dayName" }
const _hoisted_16 = { class: "dataInfo__data__time" }
const _hoisted_17 = {
  key: 0,
  class: "services"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "services__title" }, "Услуги номера", -1)
const _hoisted_19 = { class: "services__list" }
const _hoisted_20 = {
  key: 0,
  class: "iconCond",
  title: "кондиционер"
}
const _hoisted_21 = {
  key: 1,
  class: "iconNews",
  title: "газета"
}
const _hoisted_22 = {
  key: 2,
  class: "clean",
  title: "уборка"
}
const _hoisted_23 = {
  key: 3,
  class: "wifi",
  title: "wifi"
}
const _hoisted_24 = {
  key: 4,
  class: "food",
  title: "еда в номер"
}
const _hoisted_25 = {
  key: 5,
  class: "bed",
  title: "душ"
}
const _hoisted_26 = { class: "hotelCard__mainDop" }
const _hoisted_27 = { class: "hotelCard__mainDop__pol" }
const _hoisted_28 = /*#__PURE__*/_createVNode("h5", null, "Аннуляционная политика", -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "hotelCard__mainDop__info" }
const _hoisted_32 = /*#__PURE__*/_createVNode("h5", null, "Информация о номере", -1)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "separateBlock sepLine fixsepBlock" }, [
  /*#__PURE__*/_createVNode("div", { class: "separateBlock__left ovalLeft" }),
  /*#__PURE__*/_createVNode("div", { class: "separateBlock__rigth ovalRight" })
], -1)
const _hoisted_35 = { class: "hotelCard__footer" }
const _hoisted_36 = { class: "infoPrice" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Итого: ")
const _hoisted_38 = /*#__PURE__*/_createVNode("span", null, "*Без НДС", -1)
const _hoisted_39 = {
  key: 0,
  href: "#",
  class: "infoBtn"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.item)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.item.rooms[0].baseHotelRateAccessor.systemName), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.item.hotelName.bs.rus), 1 /* TEXT */)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", null, _toDisplayString(_ctx.parseDate(
                  _ctx.item.rooms[0].baseHotelRateAccessor.accessor.checkin,
                  "DD MMM"
                )), 1),
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.parseDate(
                  _ctx.item.rooms[0].baseHotelRateAccessor.accessor.checkin,
                  "dddd"
                )), 1)
              ]),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.item.rooms[0].baseHotelRateAccessor.checkInTime), 1)
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", null, _toDisplayString(_ctx.parseDate(
                  _ctx.item.rooms[0].baseHotelRateAccessor.accessor.checkout,
                  "DD MMM"
                )), 1),
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.parseDate(
                  _ctx.item.rooms[0].baseHotelRateAccessor.accessor.checkout,
                  "dddd"
                )), 1)
              ]),
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.item.rooms[0].baseHotelRateAccessor.checkOutTime), 1)
            ])
          ]),
          (_ctx.allService)
            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                _hoisted_18,
                _createVNode("ul", _hoisted_19, [
                  (_ctx.allService.cond)
                    ? (_openBlock(), _createBlock("li", _hoisted_20))
                    : _createCommentVNode("", true),
                  (_ctx.allService.news)
                    ? (_openBlock(), _createBlock("li", _hoisted_21))
                    : _createCommentVNode("", true),
                  (_ctx.allService.clean)
                    ? (_openBlock(), _createBlock("li", _hoisted_22))
                    : _createCommentVNode("", true),
                  (_ctx.allService.wifi)
                    ? (_openBlock(), _createBlock("li", _hoisted_23))
                    : _createCommentVNode("", true),
                  (_ctx.allService.food)
                    ? (_openBlock(), _createBlock("li", _hoisted_24))
                    : _createCommentVNode("", true),
                  (_ctx.allService.bath)
                    ? (_openBlock(), _createBlock("li", _hoisted_25))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _hoisted_28,
            (_ctx.cancelationPolicies)
              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.cancelationPolicies, (pol, ind) => {
                  return (_openBlock(), _createBlock("p", { key: ind }, [
                    (!!pol.dateStart)
                      ? (_openBlock(), _createBlock("span", _hoisted_29, "C " + _toDisplayString(pol.dateStartStr), 1))
                      : _createCommentVNode("", true),
                    (!!pol.dateEnd)
                      ? (_openBlock(), _createBlock("span", _hoisted_30, "До " + _toDisplayString(pol.dateEndStr), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" cтоимость возврата " + _toDisplayString(pol.refundFee.baseRefundFee) + " " + _toDisplayString(pol.currencyCode) + ". ", 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_31, [
            _hoisted_32,
            (_ctx.roomName)
              ? (_openBlock(), _createBlock("p", _hoisted_33, "Название комнаты: " + _toDisplayString(_ctx.roomName), 1))
              : _createCommentVNode("", true),
            _createVNode("p", null, _toDisplayString(_ctx.roomDescription), 1)
          ])
        ]),
        _hoisted_34,
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, [
            _hoisted_37,
            _createVNode("b", null, _toDisplayString(_ctx.priceRoom) + _toDisplayString() + " ₽ ", 1),
            _hoisted_38
          ]),
          (!_ctx.isModeOffer)
            ? (_openBlock(), _createBlock("a", _hoisted_39, "Подробнее"))
            : _createCommentVNode("", true),
          (_ctx.isModeOffer)
            ? (_openBlock(), _createBlock("span", {
                key: 1,
                class: "infoBtn",
                onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.selectTiket(...args)), ["prevent"]))
              }, "Выбрать"))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
})